export const PROPERTY_DEFAULT_LOCALE_HEADER = 'x-property-default-locale';
export const USER_SELECTED_LOCALE_HEADER = 'x-user-selected-locale';

export interface LocaleRequestState {
  availableLanguages: Array<{ localeCode: string; isDefault: boolean }>;
  localeCode: string;
}

/**
 * Builds the locale headers sent to Form Builder API. Values are omitted when
 * locale discovery has not completed or no user locale is selected.
 */
export function getLocaleRequestHeaders({
  availableLanguages,
  localeCode,
}: LocaleRequestState): Record<string, string> {
  const propertyDefaultLocale = availableLanguages.find(
    (language) => language.isDefault,
  )?.localeCode;

  return {
    ...(propertyDefaultLocale ? { [PROPERTY_DEFAULT_LOCALE_HEADER]: propertyDefaultLocale } : {}),
    ...(localeCode ? { [USER_SELECTED_LOCALE_HEADER]: localeCode } : {}),
  };
}
